import { types, actions } from './requests'
export const GETSCHEDULELIST_TYPES = {
    ...types('GETSCHEDULELIST'),
}
export const GETSCHEDULELIST_ACTIONS = {
    ...actions('GETSCHEDULELIST'),
}